import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cpf-header-wrapper',
  templateUrl: './header-wrapper.component.html',
  styleUrls: ['./header-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HeaderWrapperComponent {

}
